import ReactQuill from 'react-quill';

const { Quill } = ReactQuill;
const BlockEmbed = Quill.import('blots/block/embed');

const STYLE = {
  box: 'display:flex;align-items:center;justify-content:space-between;gap:24px;'
    + 'width:100%;padding:28px 32px;border-radius:8px;background-color:#192C39;'
    + 'margin:16px 0;flex-wrap:wrap;box-sizing:border-box;cursor:pointer;',
  copy: 'display:flex;flex-direction:column;gap:8px;flex:1;min-width:200px;color:#fff;',
  title: 'margin:0;font-family:"Work Sans",sans-serif;font-weight:600;font-size:20px;line-height:1.35;',
  subtitle: 'margin:0;font-family:"Work Sans",sans-serif;font-weight:300;font-size:14px;line-height:1.5;',
  button: 'display:flex;align-items:center;justify-content:center;flex-shrink:0;'
    + 'padding:10px 24px;border-radius:99px;background-color:#00D293;color:#192C39;'
    + 'font-family:"Work Sans",sans-serif;font-weight:600;font-size:14px;'
    + 'text-decoration:none;text-align:center;white-space:nowrap;',
};

class CtaBlockBlot extends BlockEmbed {
  static create({
    title, subtitle, buttonLabel, href,
  } = {}) {
    const node = super.create();
    node.setAttribute('style', STYLE.box);
    node.setAttribute('contenteditable', 'false');
    node.dataset.ctaTitle = title || '';
    node.dataset.ctaSubtitle = subtitle || '';
    node.dataset.ctaLabel = buttonLabel || '';
    node.dataset.ctaHref = href || '';

    const copy = document.createElement('div');
    copy.setAttribute('style', STYLE.copy);

    const titleEl = document.createElement('p');
    titleEl.setAttribute('style', STYLE.title);
    titleEl.textContent = title || '';

    const subtitleEl = document.createElement('p');
    subtitleEl.setAttribute('style', STYLE.subtitle);
    subtitleEl.textContent = subtitle || '';

    copy.appendChild(titleEl);
    copy.appendChild(subtitleEl);

    const buttonEl = document.createElement('a');
    buttonEl.setAttribute('style', STYLE.button);
    buttonEl.setAttribute('href', href || '#');
    buttonEl.setAttribute('target', '_blank');
    buttonEl.setAttribute('rel', 'noopener noreferrer');
    buttonEl.textContent = buttonLabel || '';
    buttonEl.addEventListener('click', (event) => event.preventDefault());

    node.appendChild(copy);
    node.appendChild(buttonEl);

    return node;
  }

  static value(domNode) {
    return {
      title: domNode.dataset.ctaTitle || '',
      subtitle: domNode.dataset.ctaSubtitle || '',
      buttonLabel: domNode.dataset.ctaLabel || '',
      href: domNode.dataset.ctaHref || '',
    };
  }
}

CtaBlockBlot.blotName = 'ctaBlock';
CtaBlockBlot.className = 'ql-cta-block';
CtaBlockBlot.tagName = 'DIV';

Quill.register(CtaBlockBlot);

export default CtaBlockBlot;
